<div  (mouseenter)="onMouseEnter()" (mouseout)="onMouseLeave()">
  <ng-content select="[popoverObject]" ></ng-content>
</div>
<div *ngIf="isPopover===true">
  <ng-content select="[popoverBody]"></ng-content>
</div>
  


  